export const INVALID_PAGE = 'Invalid page'
export const INVALID_OFFSET_OR_LIMIT = 'Invalid offset or limit'

export const ERROR_OCCURRED = 'Error occurred'
export const FAILED_CONNECTION = 'Failed to connect to server'
export const NOT_FOUND = 'Not found'
export const PAGE_NOT_FOUND = 'Page not found'
export const TRY_AGAIN = 'Try again'
export const BACK_TO_HOME = 'Back to homepage'
